module.exports = __webpack_public_path__ + "img/oops-network.90bb6039.svg";